export const environment = {
  ENV: 'dev',
  BASE_URL: 'https://chatbot-api.social27.com'
};

